import { protectedGet, protectedPost } from "./restUtil";
import {
  CreatePurchaseIntentResponse,
  PricingModel,
  PricingModelType,
} from "../model/pricingmodel";
import { ServerErrorResponse } from "../model/general";
import { getSessionUser, updateUser } from "./authUtil";
import { v4 as uuid } from "uuid";

// TODO: add proper type for errors.
export function getSelectedPricingModel(
  args: { type: PricingModelType } | void,
  onSuccess: (model: PricingModel) => void,
  onError: (errors: any) => void
) {
  return protectedGet("/pricing/model/selected", args, onSuccess, onError);
}

export function getSelectedPricingModelAsync(
  args: { type: PricingModelType } | void
): Promise<PricingModel> {
  return new Promise((resolve, reject) => {
    getSelectedPricingModel(args, resolve, reject);
  });
}

export function postSelectedPricingModel(
  args: { pricing_model_code: string | null },
  onSuccess: (model: PricingModel) => void,
  onError: (errors: any) => void
) {
  return protectedPost("/pricing/model/selected", args, onSuccess, onError);
}

export function postPricingModelItemPurchaseIntent(
  args: { id: string; idempotencyKey: string; save_pm?: boolean; use_saved_pm?: boolean },
  onSuccess: (secret: CreatePurchaseIntentResponse) => void,
  onError: (errors: any) => void,
  additionalParams?: Record<string, string | boolean>
) {
  const url = "/pricing/model/item/" + args.id + "/intent/purchase";
  const payload: { [key: string]: string | boolean } = {
    idempotency_key: args.idempotencyKey,
  };
  if (args.save_pm !== undefined) {
    payload.save_pm = args.save_pm;
  }
  if (args.use_saved_pm !== undefined) {
    payload.use_saved_pm = args.use_saved_pm;
  }
  return protectedPost(url, payload, onSuccess, onError, additionalParams);
}

export function postPricingModelItemPurchaseIntentAsync(args: {
  id: string;
  idempotencyKey: string;
  save_pm?: boolean;
  use_saved_pm?: boolean;
}): Promise<CreatePurchaseIntentResponse> {
  return new Promise((resolve, reject) =>
    postPricingModelItemPurchaseIntent(args, resolve, reject, { includeStatusCode: true })
  );
}

export function purchaseFreePricingModelItem(
  args: { id: string },
  onSuccess: () => void,
  onError: (errors: ServerErrorResponse) => void
) {
  const url = "/pricing/model/item/" + args.id + "/purchase";
  return protectedPost(
    url,
    undefined,
    () => {
      updateUser({
        ...getSessionUser(),
        has_purchases: true,
      });
      onSuccess();
    },
    onError
  );
}

export function generateIdempotencyKey(): string {
  return uuid().split("-").join("");
}
